import { axios } from '$app-web/api/axios';

import { Endpoints } from '../constant';

export async function updateAvatar(avatarFile: File) {
    const formData = new FormData();
    formData.append('avatar', avatarFile);

    try {
        const { status } = await axios.post(Endpoints.User.Avatar, formData);

        return status === 200;
    } catch (error) {
        return false;
    }
}
